import { FlyoutMenu } from "@omni/components/components/Navigation/FlyoutMenu/flyoutMenu";
import { cn } from "@omni/utils/styles";

export const Link = () => {
    const { active } = FlyoutMenu.Category.Link.useContext();

    return (
        <FlyoutMenu.Category.Link
            className={cn(
                "tw:text-left tw:hover:no-underline tw:flex tw:items-center tw:justify-between tw:transition-all",
                {
                    "tw:bg-tertiary/20 tw:text-primary tw:font-bold tw:hover:text-primary":
                        active,
                    "tw:text-black tw:hover:text-black": !active
                }
            )}
        >
            <i
                className={cn(
                    "las ls-xs la-angle-right tw:float-end tw:no-underline"
                )}
            />
        </FlyoutMenu.Category.Link>
    );
};
